import { Injectable } from '@angular/core';
import { OidcConfiguration } from '../../model/OidcConfiguration';
import { StorageService } from '../storage/storage.service';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  constructor(private storageService:StorageService) { }



 /**
   * Get the access Token stored on the localStorage
   * J ai simulÃ© la prÃ©sence de l'access token dans la SessionStorage .
   * en settant la valeur de agregation Ã  cette valeur :
   * {"oidc_err":false,"access_token":"I/1aARHUdYx470OsUuLM_dQwknehDQzSpnIfm22qk/A7iiZFm5hEHDSVqPZpKTVUEpUqTVpPzuJ/X1SMlLpUx5C_TQhX6DWSPHUTDTY6slnJ30T3I/odYlZTYGLz6Rix","expire":1556118569.281,"cache":{"/users/me/":{"all":[],"byFamily":{"liquidites":[],"epargne":[],"credit":[],"titres":[],"assVie":[],"epargneSal":[],"epargneRetr":[],"capitalisation":[],"autres":[]},"listFamily":[]},"/users/me/config/":{"CLE_CGU":"1.0","Date_Unsuscribe":"","useragent":"Mozilla/5.0 (Windows NT 6.1; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/72.0.3626.119 Safari/537.36","Flag_Enrolement":"1","Date_CGU":"2019-04-24","browser":"Chrome 72"}}}
   */
  public getAccessTokenPayload(): string {

         var myAccessToken = this.getAcessToken();
          if( myAccessToken!=null ){
            return myAccessToken ;
          }
        }


  public getAcessToken():string  {
    return localStorage.getItem(
      this.storageService.getStorageKey(OidcConfiguration.storageAtPostfix)
    );
  }

}
